





















































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { PaymentCalculatorService } from '../services/PaymentCalculatorService'
  
export default Vue.extend({
  props: ['product'],
  data: function() {
    return {}
  },
  computed: {
    ...mapGetters({
      rate: 'terms/rate',
      term: 'terms/term',
      financeOptions: 'terms/financeOptions',
      leaseOptions: 'terms/leaseOptions',
      currentDealer: 'dealers/currentDealer',
      currentMake: 'makes/currentMake',
      currentTrim: 'trims/currentTrim',
      frequency: 'terms/currentFrequency',
      modelId: 'models/currentModelId'
    }),
    paymentPeriods() : number {
      return PaymentCalculatorService.getPaymentPeriods(this.frequency)
    },
    payment() : number {
      return this.installOnly ? PaymentCalculatorService.calculatePayment(this.rate, this.installPrice, this.paymentPeriods, this.term) : PaymentCalculatorService.calculatePayment(this.rate, this.price, this.paymentPeriods, this.term)
    },
    installOnly() : boolean {
      return this.currentDealer.onlyInstallPrice == 1
    },
    installPrice() : number {
      return this.product.installPrice
    },
    price() : number {
      return this.installOnly ? this.installPrice : this.product.price
    },
    photo() : string {
      return this.product.images.length > 0 ? "https://res.cloudinary.com/shopaccessories/image/upload/w_400,c_scale/" + this.currentMake.name + "/products/" + this.product.images[0].photo : require('@/assets/styles/wheellogoRED.png')
    }
  },
  methods: {
    navigateToDetail() : void {
      this.$store.commit('products/setSelectedProduct', this.product)
      this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/products/' + this.product.id)
    }
  }
})
